export enum PaymentMerchantTypeEnum {
    None = 0,
    Lcw = 1,
    Mp = 2,
    MobilAsistan = 3,
}

export const PaymentMerchantTypeNames: Record<number, string> = {
    [PaymentMerchantTypeEnum.None]: 'None',
    [PaymentMerchantTypeEnum.Lcw]: 'Lcw',
    [PaymentMerchantTypeEnum.Mp]: 'Mp',
    [PaymentMerchantTypeEnum.MobilAsistan]: 'Mobil Asistan',
};
